import { render, staticRenderFns } from "./AddCustomFormItem.vue?vue&type=template&id=3b48b01c&scoped=true"
import script from "./AddCustomFormItem.vue?vue&type=script&lang=js"
export * from "./AddCustomFormItem.vue?vue&type=script&lang=js"
import style0 from "./AddCustomFormItem.vue?vue&type=style&index=0&id=3b48b01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48b01c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
